import { render, staticRenderFns } from "./GatewayDetailTable.vue?vue&type=template&id=eb34fa60&scoped=true&"
import script from "./GatewayDetailTable.vue?vue&type=script&lang=js&"
export * from "./GatewayDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./GatewayDetailTable.vue?vue&type=style&index=0&id=eb34fa60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb34fa60",
  null
  
)

export default component.exports